"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.TabsContextDefaultValue = exports.TabsContext = void 0;var _react = _interopRequireDefault(require("react"));

var _utils = require("../../lib/utils");
















var TabsContextDefaultValue = exports.TabsContextDefaultValue = {
  vertical: false,
  activeTab: '',
  size: 'large',
  getTab: _utils.emptyHandler,
  addTab: _utils.emptyHandler,
  notifyUpdate: _utils.emptyHandler,
  removeTab: _utils.emptyHandler,
  shiftFocus: _utils.emptyHandler,
  switchTab: _utils.emptyHandler
};
var TabsContext = exports.TabsContext = /*#__PURE__*/_react.default.createContext(TabsContextDefaultValue);

TabsContext.displayName = 'TabsContext';